import React from 'react';
import './ui.css';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md';
};

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary', size = 'md', className = '', type = 'button', children, ...rest
}) => (
  <button type={type} className={`ui-btn ui-btn--${variant} ui-btn--${size} ${className}`.trim()} {...rest}>
    {children}
  </button>
);
